export default __webpack_public_path__ + "a4cdbd4f3e8eb001ef36ba0a863a077f.svg";